/* Freshbliss - fade the floating WhatsApp button while scrolling - 02 Nov 2026
   It drops back to a faint hint during a scroll and returns half a second
   after the customer stops, so it never sits on top of what they are reading. */
(function () {
  if (window.__fbWaScroll) return;
  window.__fbWaScroll = true;

  var SEL = '.whatsapp-floating-button';

  function addStyle() {
    var s = document.createElement('style');
    s.textContent =
      SEL + '{transition:opacity .25s ease, transform .25s ease}' +
      SEL + '.fb-wa-dim{opacity:.12;transform:scale(.82);pointer-events:none}';
    (document.head || document.documentElement).appendChild(s);
  }

  var btn = null;
  var timer = null;

  function get() {
    if (!btn || !btn.isConnected) btn = document.querySelector(SEL);
    return btn;
  }

  function onScroll() {
    var b = get();
    if (!b) return;
    b.classList.add('fb-wa-dim');
    clearTimeout(timer);
    timer = setTimeout(function () {
      b.classList.remove('fb-wa-dim');
    }, 500);
  }

  function start() {
    addStyle();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
